@if (loadingSpace) {
  <div class="wrapper">
    <div class="iconWrapper">
      @if (loadingSpace.type === 1 && loadingSpace.set) {
        <gl-icon
          class="vehicleSetIcon"
          name="trailer"
        ></gl-icon>
      }
      @if (loadingSpace.type === 1) {
        <gl-icon class="vehicleIcon" name="semi-trailer"></gl-icon>
      }
      @if (loadingSpace.type === 2) {
        <gl-icon class="vehicleIcon" name="container"></gl-icon>
      }
      @if (loadingSpace.type === 3) {
        <gl-icon class="vehicleIcon" name="palette"></gl-icon>
      }
      @if (loadingSpace.type === 4) {
        <gl-icon class="vehicleIcon" name="airContainer"></gl-icon>
      }
    </div>
    <div class="description">
      <div class="loadingSpaceName">{{ loadingSpace.name | translate }}</div>
      <div class="loadingSpaceDimmension">
        {{ loadingSpace.length }} x {{ loadingSpace.width }} x
        {{ loadingSpace.height | unit: 'length':false }} |
        {{ loadingSpace.limit | unit: 'weight':false }}
      </div>
    </div>
    @if (isButtons) {
      <div class="buttons">
        <button data-ctx="button-add-loading-space" small-button (click)="addLoadingSpace($event)">
          {{ 'add' | translate }}
        </button>
        <button data-ctx="button-edit-loading-space" small-icon-button (click)="editLoadingSpace($event)">
          <gl-icon name="edit"></gl-icon>
        </button>
      </div>
    }
  </div>
}
